export default class Cwe
{
  constructor(cwe = {}) {
    this.id = cwe.id || null
    this.number = cwe.number || null
    this.description = cwe.description || ''
    this.false_positive_types = cwe.false_positive_types || []
  }

  static mutations() {
    return {
      setCwe: (state, payload) => state.cwe = new Cwe(payload),
      addFalsePostiveType: (state, payload) => state.cwe.false_positive_types.push(payload)
    }
  }
}